import { Route, Routes } from "react-router-dom";

import {
  CreateDefaultAccountForExistingProfile,
  NoDefaultAccountExists,
  SignUp,
} from "../../pages";

export const NoDepartmentCreateAccountLayout = () => {
  return (
    <Routes>
      <Route
        path="/create-new-account"
        element={<CreateDefaultAccountForExistingProfile />}
      />
      <Route path="*" element={<NoDefaultAccountExists />} />
    </Routes>
  );
};
